import { render, staticRenderFns } from "./upload-attachment-dialog.vue?vue&type=template&id=6c9d7c2a&"
import script from "./upload-attachment-dialog.vue?vue&type=script&lang=js&"
export * from "./upload-attachment-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports